module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Ruller-7510a0d3c5f291a4f5f74fe0f116f969.svg";